import { useCallback, useState } from 'react'

const STORAGE_KEY = 'td_report_sound_enabled'

function readPreference(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) !== 'false'
  } catch {
    return true
  }
}

/** Persisted on/off preference for report sound cues. Defaults to on. */
export function useSoundPreference() {
  const [enabled, setEnabled] = useState<boolean>(readPreference)

  const toggle = useCallback(() => {
    setEnabled((prev) => {
      const next = !prev
      try {
        window.localStorage.setItem(STORAGE_KEY, String(next))
      } catch {
        /* storage unavailable — preference lasts for this visit only */
      }
      return next
    })
  }, [])

  return { enabled, toggle }
}
